import TagManager from "react-gtm-module";

function OnboardingNextButton({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "onboarding_next_button",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default OnboardingNextButton;
